module.exports = __webpack_public_path__ + "static/media/house_13.113d7606.jpg";